export default __webpack_public_path__ + "static/portrait-a674a557be95008a2a45ba8378216c8a.jpg";